
import { mapState } from 'vuex';
import VolkswagenLayout from './layouts/VolkswagenLayout.vue';
import SeatLayout from './layouts/SeatLayout.vue';
import AudiLayout from './layouts/AudiLayout.vue';
import CupraLayout from './layouts/CupraLayout.vue';
import GeneralLayout from './layouts/GeneralLayout.vue';

export default {
  name: 'App',
  components: {
    VolkswagenLayout,
    SeatLayout,
    AudiLayout,
    CupraLayout,
    GeneralLayout,
  },
  computed: mapState(['layout']),
};
